<template>


  <div class="wrapper_btn">


    <router-link
        :to="to"
        custom
        v-slot="{ navigate }"
    >

      <button type="submit"
              role="button"
              id="cta_next"
              class="cta next"
              @click="onButtonClick($event, navigate)"
      >

        <span>{{ label }}</span>
      </button>

    </router-link>
  </div>
</template>

<script>
export default {
  name : "NextStepButton",
}
</script>

<script setup>

let props = defineProps( [ "to", "label", "canSubmit", "elementToFocusIfCannotProceed" ] )

function onButtonClick ( event, navigate )
{
  if ( props.canSubmit() )
  {
    navigate();
  } else
  {
    event.preventDefault();

    let scrollToY = 0;

    if ( props.elementToFocusIfCannotProceed )
    {
      const headerHeight = document.querySelector( '#reservations_steps_nav' ).getBoundingClientRect().height;

      scrollToY = window.scrollY + props.elementToFocusIfCannotProceed.getBoundingClientRect().top - headerHeight - 50; // 50 = buffer
    }

      window.scrollTo( {
        top      : scrollToY,
        left     : 0,
        behavior : 'smooth',
      } );
  }

}
</script>
